var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNgc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9239 -8250)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-9239 8250)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.304 23.567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5672.85,1691.512a3.21,3.21,0,1,1,3.253-3.078A3.118,3.118,0,0,1,5672.85,1691.512Z",
    transform: "translate(-14950.666 6555.81)",
    fill: "#71aff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5546.888,1691.456a3.212,3.212,0,1,1,3.229-3.187A3.148,3.148,0,0,1,5546.888,1691.456Z",
    transform: "translate(-14833.738 6555.866)",
    fill: "#71aff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2668.477,757.555a3.249,3.249,0,0,1-3.264,3.27,3.264,3.264,0,0,1-.011-6.529A3.25,3.25,0,0,1,2668.477,757.555Zm-3.279,1.661a1.656,1.656,0,1,0-1.657-1.654A1.613,1.613,0,0,0,2665.2,759.216Z",
    transform: "translate(-11955.898 7493.97)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2668.477,757.555a3.249,3.249,0,0,1-3.264,3.27,3.264,3.264,0,0,1-.011-6.529A3.25,3.25,0,0,1,2668.477,757.555Zm-3.279,1.661a1.656,1.656,0,1,0-1.657-1.654A1.613,1.613,0,0,0,2665.2,759.216Z",
    transform: "translate(-11947.516 7493.97)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2668.477,757.555a3.249,3.249,0,0,1-3.264,3.27,3.264,3.264,0,0,1-.011-6.529A3.25,3.25,0,0,1,2668.477,757.555Zm-3.279,1.661a1.656,1.656,0,1,0-1.657-1.654A1.613,1.613,0,0,0,2665.2,759.216Z",
    transform: "translate(-11939.133 7493.97)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2668.477,757.555a3.249,3.249,0,0,1-3.264,3.27,3.264,3.264,0,0,1-.011-6.529A3.25,3.25,0,0,1,2668.477,757.555Zm-3.279,1.661a1.656,1.656,0,1,0-1.657-1.654A1.613,1.613,0,0,0,2665.2,759.216Z",
    transform: "translate(-11947.516 7479.775)",
    fill: "#707070",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNgc);
export default __webpack_public_path__ + "static/media/icon-ngc.3eb0d59b.svg";
export { ForwardRef as ReactComponent };